import { transparentize } from "polished"
import styled from "styled-components"
import { theme } from "@aistihealth/web-common/src/util/styles/theme"

export const FormInputDescriptionText = styled.span`
  ${theme.textStyle("paragraph", "small", "normal")}
  color: ${transparentize(0.5, theme.colors.black)};
`
